/** Short modules (few submodules) — top row. */
export const MODULE_ROW_TOP = ['registration', 'business', 'business-development']
/** Dense modules — bottom row. */
export const MODULE_ROW_BOTTOM = ['workplace', 'discovery', 'knowledge']
export const KNOWN_MODULE_KEYS = new Set([...MODULE_ROW_TOP, ...MODULE_ROW_BOTTOM])

/** Market Research submenu order on the user app (APP_MENU DISCOVERY_GROUP). */
export const DISCOVERY_SUBMODULE_ORDER = [
  'recommendations',
  'vendors',
  'state-local-contract-opportunities',
  'state-local-forecasts',
  'state-local-awards',
  'contract-opportunities',
  'grant-opportunities',
  'nsn-opportunities',
  'contract-awards',
  'federal-agents',
  'federal-agencies-offices',
  'government-files',
  'code-categories',
  'pipelines',
  'my-pursuits',
  'tasks',
  'saved-searches',
]

const DISCOVERY_SUBMODULE_RANK = DISCOVERY_SUBMODULE_ORDER.reduce((acc, key, index) => {
  acc[key] = index
  return acc
}, {})

export const sortDiscoverySubmodules = (submodules) => {
  if (!Array.isArray(submodules)) return []
  return [...submodules].sort((a, b) => {
    const aRank = DISCOVERY_SUBMODULE_RANK[a?.key]
    const bRank = DISCOVERY_SUBMODULE_RANK[b?.key]
    const aIndex = aRank === undefined ? Number.MAX_SAFE_INTEGER : aRank
    const bIndex = bRank === undefined ? Number.MAX_SAFE_INTEGER : bRank
    return aIndex - bIndex
  })
}

export const MODULE_LABELS = {
  workplace: 'Dashboard',
  registration: 'Registration',
  discovery: 'Market Research',
  'business-development': 'Business Development',
  business: 'Marketing',
  knowledge: 'Bid Ready',
}

export { SUBMODULE_LABELS, getSubmoduleLabel } from '../../../../utils/helpers'

export const indexModulesByKey = (modules) => {
  if (!Array.isArray(modules)) return {}
  return modules.reduce((acc, module) => {
    if (module?.key) acc[module.key] = module
    return acc
  }, {})
}

export const pickModulesByKeys = (modulesByKey, keys) =>
  keys.map((key) => modulesByKey[key]).filter(Boolean)

export const getLeftoverModules = (modules) =>
  (modules || []).filter((module) => module?.key && !KNOWN_MODULE_KEYS.has(module.key))

export const getTabOptionsList = (subscriptionSettings, optionTab) => {
  const tabUsers = subscriptionSettings?.find((obj) => obj.idTab == optionTab)
  return tabUsers?.existingUsers?.optionsList || []
}

const withToggledSubmodules = (submodules, checked) =>
  submodules.map((opt) => ({
    ...opt,
    aCheckBox: checked,
    vCheckBox: checked,
    active: checked,
  }))

export const toggleModuleInOptions = (optionLists, moduleKey, checked) =>
  optionLists.map((option) => {
    if (option.key != moduleKey) return option
    return {
      ...option,
      active: checked,
      submodules: withToggledSubmodules(option.submodules, checked),
    }
  })

const withVisibilityCheckbox = (opt, isChecked) => ({
  ...opt,
  vCheckBox: isChecked,
  aCheckBox: isChecked ? opt.aCheckBox : false,
  active: isChecked ? opt.aCheckBox : false,
})

const withAccessibilityCheckbox = (opt, isChecked) => ({
  ...opt,
  aCheckBox: isChecked,
  vCheckBox: isChecked ? true : opt.vCheckBox,
  active: isChecked,
})

const updateMatchingSubmodule = (submodules, submoduleKey, isChecked, vCheck) =>
  submodules.map((opt) => {
    if (opt.key != submoduleKey) return opt
    return vCheck ? withVisibilityCheckbox(opt, isChecked) : withAccessibilityCheckbox(opt, isChecked)
  })

export const toggleSubmoduleInOptions = (optionLists, moduleKey, submoduleKey, isChecked, vCheck) =>
  optionLists.map((option) => {
    if (option.key != moduleKey) return option
    return {
      ...option,
      submodules: updateMatchingSubmodule(option.submodules, submoduleKey, isChecked, vCheck),
    }
  })

export const mapSubscriptionTabOptions = (subscriptionSettings, optionTab, getOptionLists, transformOptions) =>
  subscriptionSettings.map((tab) => {
    if (tab.idTab != optionTab) return tab
    return {
      ...tab,
      existingUsers: { optionsList: transformOptions(getOptionLists(tab)) },
    }
  })
